const messages = {
  payoutsDescription: "List of paid out BS+ items.",
  paidOut: "paid out",
  makeChoice: "Treffen Sie hier Ihre Wahl",
  seeAll: "Alle anzeigen",
  clear: "Löschen",
  back: "Zurück",
  save: "Speichern",
  close: "Schliessen",
  of: "Von",
  to: "Bis",
  copyrights: "© {date} Bridgestone Solutions. Alle Rechte vorbehalten.",
  pageNotFound: "Seite nicht gefunden",
  accessDenied: "Zugriff abgelehnt",
  search: "Suche",
  year: "Jahr",
  buttons: {
    loading: "Laden...",
    export: "Exportieren",
    delete: "Löschen",
    save: "Speichern",
    cancel: "Abbrechen",
    next: "Weiter",
    back: "ZURÜCK",
    skip: "Überspringen",
    send: "Senden",
    pointsList: "Zum kontoauszug",
    clear: "Löschen",
    readNow: "Jetzt lesen",
    more: "Mehr",
    close: "Schliessen",
    reportError: "Fehler melden",
    accept: "Akzeptieren",
    download: "Herunterladen",
    downloadAll: "Alles herunterladen",
    dealerInfoDownload: "HÄNDLERINFORMATION HERUNTERLADEN",
    toTheBasket: "In den Warenkorb",
    toOrderDelivery: "Weiter zur Lieferadresse",
    discover: "entdecken",
    newAddress: "Neue lieferadresse erstellen",
    selectAddressBtn: "Adresse auswählen",
    toOrderSummary: "Zur Bestellübersicht",
    placeOrder: "Verbindlich Bestellen",
    toDashboard: "Zur Startseite",
    newOrder: "Neue Bestellung",
    userOrders: "Zu ihren bestellungen",
    toSearch: "Suchen",
    select: "Auswählen",
    moreCustomerNumbers: "+ WEITERE KDNR. ANGEBEN",
    loadMore: "Weitere umsätze laden",
    toStaffDashboard: "Zum Dashboard",
    toQuiz: "Zum Quiz",
    vouchers: "Zur Punkteübersicht",
    exchangeVoucher: "Gutscheincode einlösen",
    confirm: "BESTÄTIGEN",
    clearFilters: "Filter zurücksetzen",
    selectAll: "Alles auswählen",
    downloadSelection: "Auswahl herunterladen",
    deselectAll: "Auswahl aufheben",
    setFilters: "Setzen Sie bitte maximal einen Filter pro Spalte",
    sharePoints: "Punkte teilen",
    create: "Erstellen",
    update: "Aktualisieren",
    toDiscover: "Entdecken",
    directBuy: "Direkt bestellen",
    sendRequest: "Anfrage senden",
    showAllProducts: "Zum Prämienshop",
    reset: "Neue Berechnung",
    calculate: "Berechnen",
    toBDrive: "Zu B-Drive",
    preview: "Vorschau",
    makeContact: "Kontakt aufnehmen",
    clickHere: "Details ansehen",
    all: "Alle",
  },
  tooltips: {
    info: "Brauchen Sie Hilfe? +43 1 6141388",
  },
  confirmation: {
    header: "Bestätigung erforderlich",
    message: "Möchten Sie diesen Eintrag löschen?",
  },
  nav: {
    consents: "Einwilligungen",
    dashboard: "Hauptseite",
    accountDashboard: "Hauptseite",
    account: "Mein Konto",
    mailbox: "Postfach",
    singleMailbox: "Nachrichten",
    stammdaten: "Stammdaten",
    news_feeds: "Aktuelles",
    pointsOverview: "Mein Punktekonto",
    rewardsOverview: "Mein Punktekonto",
    about: 'Über Bridgestone <span class="text-danger">Plus</span>',
    service_number: "Kontakt & Service",
    shop: "Prämienshop",
    salesPromotions: "Verkaufsförderung",
    shopCategory: "Prämienshop",
    productDetails: "Produktdetails",
    userOrders: "Meine Bestellungen",
    shoppingCart: "Warenkorb",
    orderDelivery: "Lieferadresse",
    orderSummary: "Bestellübersicht",
    orderComplete: "Bestellung abgeschlossen",
    text_page: "Statische Seite",
    staff: "Dashboard",
    onlineTrainings: "Online Trainings",
    trainings: "Schulungen",
    training: "Training",
    trainingForm: "Training",
    staffVouchers: "Gutscheine",
    wholesalerVouchers: "Gutscheine",
    brochure_prices: "Produktbroschüren",
    investment: "Investitionsunterstuetzung",
    media: "Medienbibliothek",
    wholesaler: "Händler-Dashboard",
    contact_service: "Kontakt & Service",
    onlineTrainingCategory: "Online trainings",
    onlineTrainingCategoryType: "Online trainings",
    medias: "Medienbibliothek",
    preislisten: "Produktinformationen",
    pricat: "Pricat",
    sales_support: "Verkaufsunterstützung",
    onlineVisibility: "Uberall",
    productInfo: "Produktinformationen",
    fuelCalculator: "Spritspar-Rechner",
    bridgestoneSchulungen: "Bridgestone Schulungen",
    externeTraining: "Externe Schulungen",
    favoriteProducts: "Lieblingsprodukte",
    bridgestoneSingleSchulungen: "Bridgestone Schulungen Training",
    preislistenList: "Preislisten",
    bDrive: "Produkt-Abbildungen",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Teilnahmebedingungen",
    first_stop: "Bridgestone Reifengarantie",
    payouts: "Payouts",
  },
  breadcrumbs: {
    dashboard: "Hauptseite",
    accountDashboard: "Hauptseite",
    account: "Mein Konto",
    mailbox: "Postfach",
    singleMailbox: "Nachrichten",
    stammdaten: "Stammdaten",
    news_feeds: "Aktuelles",
    pointsOverview: "Mein Punktekonto",
    rewardsOverview: "Mein Punktekonto",
    about: 'Über Bridgestone <span class="text-danger">Plus</span>',
    service_number: "Kontakt & Service",
    shop: "Prämienshop",
    salesPromotions: "Verkaufsförderung",
    shopCategory: "Prämienshop",
    productDetails: "Produktdetails",
    userOrders: "Meine Bestellungen",
    shoppingCart: "Warenkorb",
    orderDelivery: "Lieferadresse",
    orderSummary: "Bestellübersicht",
    orderComplete: "Bestellung abgeschlossen",
    staff: "Dashboard",
    onlineTrainings: "Online Trainings",
    trainings: "Schulungen",
    training: "Training",
    trainingForm: "Training",
    staffVouchers: "Gutscheine",
    wholesalerVouchers: "Gutscheine",
    brochure_prices: "Produktbroschüren",
    investment: "Investitionsunterstuetzung",
    media: "Medienbibliothek",
    wholesaler: "Händler-Dashboard",
    contact_service: "Kontakt & Service",
    onlineTrainingCategory: "Online trainings",
    onlineTrainingCategoryType: "Online trainings",
    medias: "Medienbibliothek",
    preislisten: "Produktinformationen",
    pricat: "Pricat",
    sales_support: "Verkaufsunterstützung",
    onlineVisibility: "Uberall",
    productInfo: "Produktinformationen",
    fuelCalculator: "Spritspar-Rechner",
    bridgestoneSchulungen: "Bridgestone Schulungen",
    externeTraining: "Externe Schulungen",
    favoriteProducts: "Lieblingsprodukte",
    bridgestoneSingleSchulungen: "Bridgestone Schulungen Training",
    preislistenList: "Preislisten",
    bDrive: "Produkt-Abbildungen",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Teilnahmebedingungen",
    first_stop: "Bridgestone Reifengarantie",
    payouts: "Payouts",
  },
  menu: {
    account: "Mein Konto",
    plus: 'Über Bridgestone <span class="text-danger">Plus</span>',
    salesSupport: "Verkaufsunterstützung",
    mailbox: "Postfach",
    about: 'Über Bridgestone <span class="text-danger">Plus</span>',
    trainingAndCourses: "Trainings & Schulungen",
    externalTraining: "Individuelle Schulungen",
    productInfo: "Produktinformationen",
    productBrochures: "Produktbroschüren",
    priceLists: "Preislisten",
    price: "Pricat",
    complaintForm: "Beanstandungsformular",
    sales_support: "Verkaufsunterstützung",
    contact_service: "Kontakt & Service",
    logOut: "Ausloggen",
    news: "Aktuelles",
    news_feeds: "Aktuelles",
    service_number: "Kontakt & Service",
    salesPromotions: "Verkaufsförderung",
    shop: "Prämienshop",
    onlineTrainings: "Online Trainings",
    trainings: "Trainings & Schulungen",
    stammdaten: "Stammdaten",
    brochure_prices: "Produktbroschüren & Preislisten",
    media: "Medien",
    medias: "Medienbibliothek",
    preislisten: "Preislisten",
    promotions: "Aktionen",
  },
  validation: {
    requiredField: "Pflichtfeld",
  },
  sortBy: {
    default: "Sortieren nach",
    desc: "Sortieren nach: Neueste",
    asc: "Sortieren nach: Älteste",
    name: "Namen",
    date: "Datum",
    choiceBy: "Auswahl sortieren nach",
  },
  month: {
    1: "Januar",
    2: "Februar",
    3: "März",
    4: "April",
    5: "Mai",
    6: "Juni",
    7: "Juli",
    8: "August",
    9: "September",
    10: "Oktober",
    11: "November",
    12: "Dezember",
  },
};

export default {
  messages,
};
